import React, { useState, useRef } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';

import FileInput from '@components/FileInput';

const FileDemo = () => {
  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef(null);
  const [filesValues, setFilesValues] = useState([])
  const [filesValuesS, setFilesValuesS] = useState([])
  
  const onUpload = () => {
    toast.current.show({
      severity: 'info',
      summary: 'Success',
      detail: 'File Uploaded',
      life: 3000,
    });
  };

  const onTemplateSelect = (e) => {
    let _totalSize = totalSize;
    e.files.forEach((file) => {
      _totalSize += file.size;
    });

    setTotalSize(_totalSize);
  };

  const onTemplateUpload = (e) => {
    let _totalSize = 0;
    e.files.forEach((file) => {
      _totalSize += file.size || 0;
    });

    setTotalSize(_totalSize);
    toast.current.show({
      severity: 'info',
      summary: 'Success',
      detail: 'File Uploaded',
    });
  };

  const onTemplateRemove = (file, callback) => {
    setTotalSize(totalSize - file.size);
    callback();
  };

  const onTemplateClear = () => {
    setTotalSize(0);
  };

  const uploadFile = (files, isImage) => {
    // e.preventDefault()
    // console.log('.-----Z>', e)
    // const files = e.target.files || e.dataTransfer.files
    const [ file ] = files
    const { name: fileName } = file
    const localUrl = URL.createObjectURL(file)
    const fileExtension = fileName.split('.').pop()
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage
    }
    setFilesValues(prevMovies => ([...prevMovies, ...[data]]));
  }

  const removeAllFiles = () => {
    setFilesValues([])
  }

  const removeFile = (doc) => {
    const index = filesValues.indexOf(doc);
    const fileValuesTempRe = filesValues.filter((item, i) => i !== index) 
    setFilesValues(fileValuesTempRe)
  }

  const uploadFileS = (files, isImage) => {
    // e.preventDefault()
    // console.log('.-----Z>', e)
    // const files = e.target.files || e.dataTransfer.files
    const [ file ] = files
    const { name: fileName } = file
    const localUrl = URL.createObjectURL(file)
    const fileExtension = fileName.split('.').pop()
    const data = {
      fileName,
      currentValue: localUrl,
      file,
      fileExtension,
      isImage
    }
    setFilesValuesS([data]);
  }

  const removeAllFilesS = () => {
    setFilesValuesS([])
  }

  const removeFileS = () =>  {
    setFilesValuesS([])
  }

  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : '0 B';

    return (
      <div
        className={className}
        style={{
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {chooseButton}
        {uploadButton}
        {cancelButton}
        <ProgressBar
          value={value}
          displayValueTemplate={() => `${formatedValue} / 1 MB`}
          style={{ width: '300px', height: '20px', marginLeft: 'auto' }}
        />
      </div>
    );
  };

  const itemTemplate = (file, props) => (
    <div className="p-d-flex p-ai-center p-flex-wrap">
      <div className="p-d-flex p-ai-center" style={{ width: '40%' }}>
        <img
          alt={file.name}
          role="presentation"
          src={file.objectURL}
          width={100}
        />
        <span className="p-d-flex p-dir-col p-text-left p-ml-3">
          {file.name}
          <small>{new Date().toLocaleDateString()}</small>
        </span>
      </div>
      <Tag
        value={props.formatSize}
        severity="warning"
        className="p-px-3 p-py-2"
      />
      <Button
        type="button"
        icon="pi pi-times"
        className="p-button-outlined p-button-rounded p-button-danger p-ml-auto"
        onClick={() => onTemplateRemove(file, props.onRemove)}
      />
    </div>
  );

  const emptyTemplate = () => (
    <div className="p-d-flex p-ai-center p-dir-col">
      <i
        className="pi pi-image p-mt-3 p-p-5"
        style={{
          fontSize: '5em',
          borderRadius: '50%',
          backgroundColor: 'var(--surface-b)',
          color: 'var(--surface-d)',
        }}
      />
      <span
        style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }}
        className="p-my-5"
      >
        Drag and Drop Image Here
      </span>
    </div>
  );

  const chooseOptions = {
    icon: 'pi pi-fw pi-images',
    iconOnly: true,
    className: 'custom-choose-btn p-button-rounded p-button-outlined',
  };
  const uploadOptions = {
    icon: 'pi pi-fw pi-cloud-upload',
    iconOnly: true,
    className:
      'custom-upload-btn p-button-success p-button-rounded p-button-outlined',
  };
  const cancelOptions = {
    icon: 'pi pi-fw pi-times',
    iconOnly: true,
    className:
      'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined',
  };

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="card">
          <h5>Advanced</h5>
          <FileUpload
            name="demo[]"
            url="./upload.php"
            onUpload={onUpload}
            multiple
            accept="image/*"
            maxFileSize={1000000}
          />

          <h5>Basic</h5>
          <FileUpload
            mode="basic"
            name="demo[]"
            url="./upload.php"
            accept="image/*"
            maxFileSize={1000000}
            onUpload={onUpload}
          />
        </div>
      </div>

      <div className="p-col-12">
        <div className="card">
          <h5>Template</h5>
          <FileUpload
            ref={fileUploadRef}
            name="demo[]"
            url="https://primefaces.org/primereact/showcase/upload.php"
            accept="pdf/*"
            maxFileSize={1000000}
            onUpload={onTemplateUpload}
            onSelect={onTemplateSelect}
            onError={onTemplateClear}
            onClear={onTemplateClear}
            headerTemplate={headerTemplate}
            itemTemplate={itemTemplate}
            emptyTemplate={emptyTemplate}
            chooseOptions={chooseOptions}
            uploadOptions={uploadOptions}
            cancelOptions={cancelOptions}
          />
        </div>
      </div>

      <div className="p-col-12">
        <h5>Multiple</h5>
        <FileInput
          onChangeFile={uploadFile}
          files={filesValues}
          removeAllFiles={removeAllFiles}
          removeFile={removeFile}
          // maxFiles={4}
          // accept="image/*"
          // maxFileSize={100000}
          // widthImg={231}
          // heightImg={131}
        />
      </div>

      <div className="p-col-12">
        <h5>Solo 1 archivo con peso máximo</h5>
        <FileInput
          onChangeFile={uploadFileS}
          files={filesValuesS}
          removeAllFiles={removeAllFilesS}
          removeFile={removeFileS}
          accept="image/*"
          maxFileSize={100000}
          // widthImg={413}
          // heightImg={531}
        />
      </div>
    </div>
  );
};

export default FileDemo;
